import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-setupussd',
  templateUrl: './setupussd.component.html',
  styleUrls: ['./setupussd.component.css']
})
export class SetupussdComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  displayNext() {
    this.router.navigate(['/setup5']);
  }

}
